import React from 'react';
import { Route } from 'react-router-dom';
import { AUTH_CALLBACK_PATHNAME, verifyConfig } from './config';
import Callback from './pages/Callback';
import Logout from './pages/Logout';
import AccessToken from './pages/AccessToken';

const authRoutes = ({
  fetchViewer,
  onFreshLogin,
}: {
  fetchViewer: () => Promise<unknown>;
  onFreshLogin?: () => void;
}) => {
  verifyConfig();

  return [
    <Route key={AUTH_CALLBACK_PATHNAME} path={AUTH_CALLBACK_PATHNAME}>
      <Callback fetchViewer={fetchViewer} onFreshLogin={onFreshLogin} />
    </Route>,
    <Route key="/logout" path="/logout" component={Logout} />,
    ...(process.env.NODE_ENV === 'development'
      ? [<Route key="/dev/access-token" path="/dev/access-token" component={AccessToken} />]
      : []),
  ];
};

export default authRoutes;
